<template>
  <div class="payout-trans-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.complete_time') }}</div>
              <el-date-picker
                v-model="search.complete_times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.recipient_channel') }}</div>
              <el-select v-model="search.recipient_channel" filterable class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in bankList"
                  :key="index"
                  :label="item.bank_code"
                  :value="item.bank_code"
                />
              </el-select>
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.transaction_status') }}</div>
              <el-select v-model="search.po_trans_status" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in poTransactionStatusMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.merchant_order_id') }}</div>
              <el-input v-model="search.merchant_order_id" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.transaction_id') }}</div>
              <el-input v-model="search.transaction_id" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <!-- <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.app_name') }}</div>
              <el-input v-model="search.app_name" size="small" type="text" class="filter-item-value" clearable />
            </div> -->
            <div class="filter-item" />
            <div class="filter-item" />
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
              <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>

    <!-- <div class="total-container">
      <div class="total-item">{{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ total_count }}</span>
      </div>
      <div class="total-item">{{ $t('data.total_amount') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_amount | toDivideWithDot }}</span>
      </div>
      <div class="total-item">{{ $t('data.total_fee') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_fee | toDivideWithDot }}</span>
      </div>

    </div> -->
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.recipient_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.recipient_channel || '/' }}</span>
          </template>
        </el-table-column>

          <el-table-column v-if="isShowFXRow" :label="$t('data.source_amount')" align="center">
            <template slot-scope="scope">
              <span> {{ scope.row.source_amount | toDivideWithDot }} {{ scope.row.source_currency  }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.destination_amount')" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.transaction_type === TRANSACTION_TYPE_FX">
                 {{ scope.row.destination_amount  | toDivideWithDot }} {{ scope.row.destination_currency  }}
              </div>
              <div v-else>
                {{ scope.row.po_trans_amount | toDivideWithDot }}
                <span v-if="isShowFXRow">{{ $store.getters.currency }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchant.service_fee')" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.transaction_type === TRANSACTION_TYPE_FX">{{  scope.row.mch_foreign_exchange_fee_resp.fee_split | toDivideWithDot }} {{ scope.row.mch_foreign_exchange_fee_resp.fee_split_currency  }}</div>
              <div v-else>{{ scope.row.fee_split | toDivideWithDot }}  <span v-if="isShowFXRow">{{ $store.getters.currency }}</span></div>
            </template>
          </el-table-column>

        <!-- <el-table-column :label="$t('merchant.service_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.disbursement_fee && scope.row.disbursement_fee.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchantAccount.po_trans_status')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getPoTransactionStatusStyle(scope.row.po_trans_status)">{{ getPoTransactionStatusMap(scope.row.po_trans_status,scope.row.refund_type) }}</el-tag>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.app_name }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchantAccount.create_time')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.complete_time')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" :label="$t('data.remark')" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.remark || scope.row.remark.length<=10">{{ scope.row.remark }}</span>
            <el-tooltip v-else effect="light" :content="scope.row.remark" placement="top">
              <span class="show-ellipsis" style="cursor: pointer;display:inline-block;max-width: 100px;">{{ scope.row.remark }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
    <po-details-modal ref="poMentDetailsModal" :detail-id="detailId" />
  </div>
</template>

<script>

import { fetchPayoutDetailInfo, fetchPayoutDetailInfoAllList } from '@/api/settlement/settlement'
import { fetchDisbursementBankNameList } from '@/api/components/components'

import { poTransStatusWithRefundMap } from '@/utils/maps'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'

import { appointDate } from '@/utils/index.js'
export default {
  name: 'Payout_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    PoDetailsModal: () => import('./Modal/PoDetailsModal')
  },
  data() {
    this.TRANSACTION_TYPE_FX = 4
    return {
      showFilterContent: true,
      search: {
        po_trans_status: null, // 交易状态
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        complete_times: [],
        recipient_channel: '',
        app_name: ''
      },
      bankList: [],
      tableData: [],
      total_amount: 0,
      total_fee: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: '',
      downloading: false
    }
  },
  computed: {
    poTransactionStatusMap() {
      let list = poTransStatusWithRefundMap()
      list = list.map(lm => {
        if (lm.value === 2) {
          lm.value = 125
        }
        return lm
      }).filter(item => item.value !== 1 && item.value !== 5)
      return list
    },
    getPoTransactionStatusMap() {
      return function(value, refund_type) {
        if (refund_type === 2) {
          value = 99
        }
        return poTransStatusWithRefundMap(value).label
      }
    },
    getPoTransactionStatusStyle() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    },
    isShowFXRow(){
      return this.tableData?.some(item => item.transaction_type === this.TRANSACTION_TYPE_FX)
    }
  },
  created() {
    this.handleFilter()
    this.getAllChannelList()
  },
  methods: {
    getAllChannelList() {
      // 按当前商户国家过滤收款渠道银行列表
      fetchDisbursementBankNameList({ country_code: this.$store.getters.curCountry.country_code }).then(res => {
        this.bankList = res.data
      })
    },
    getPayoutDetailInfo(params = {}) {
      this.listLoading = true
      fetchPayoutDetailInfo(params).then(res => {
        const { total, list = [], current, total_amount, total_fee } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.total_amount = total_amount
        this.total_fee = total_fee
        this.total_count = total
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { po_trans_status, recipient_channel, times = [], complete_times = [], merchant_order_id, transaction_id, app_name } = this.search
      let params = {
        start_date_time: times && times[0],
        end_date_time: times && times[1],
        complete_start_date_time: complete_times && complete_times[0],
        complete_end_date_time: complete_times && complete_times[1],
        mch_order_id: merchant_order_id,
        po_trans_status,
        recipient_channel,
        transaction_country: this.$store.getters.curCountry.country_code,
        transaction_id,
        app_name,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      if (!this.$store.getters.isPii){
        if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 15)) {
          this.$message.warning('The maximum date range  is limited to 15 days, please select again')
          return
        }
        if (!this.$commonFn.checkSubmitDateLimit(this.search.complete_times, 15)) {
          this.$message.warning('The maximum date range  is limited to 15 days, please select again')
          return
        }
      }
      const params = this.getParams(otherParams)
      this.getPayoutDetailInfo(params)
    },

    onClickDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },

    showPayDetailModal() {
      this.$refs.poMentDetailsModal.changModalStatus(true)
    },

    onClickDowmloadBtn() {
      if (!this.$store.getters.isPii) {
        if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 31)) {
          this.$message.warning('The maximum date range  is limited to 31 days, please select again')
          return
        }
        if (!this.$commonFn.checkSubmitDateLimit(this.search.complete_times, 31)) {
          this.$message.warning('The maximum date range  is limited to 31 days, please select again')
          return
        }
      }
      const params = this.getParams()
      this.downloading = true
      fetchPayoutDetailInfoAllList(params).then(res => {
        const { data } = res
        if (!data.is_async) {
          const { list } = data
          this.handleXlsxData(list).then((downloadData) => {
            exportXlsx(downloadData, 'Payout_Trans_Details')
          })
        } else {
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('merchantAccount.merchant_order_id'),
        this.$t('customerService.transaction_id'),
        this.$t('merchantAccount.amount'),
        this.$t('merchant.service_fee'),
        this.$t('merchantAccount.recipient_name'),
        this.$t('merchantAccount.recipient_account'),
        this.$t('data.payment_method_channel'),
        this.$t('data.remitting_bank'),
        this.$t('data.remitting_account'),
        this.$t('merchantAccount.po_trans_status'),
        // this.$t('customerService.app_name'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]]

      // const toDivideWithDot = this.$options.filters['toDivideWithDot']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.merchant_order_id,
            tr.transaction_id,
            tr.amount,
            tr.fee,
            tr.recipient_name,
            tr.recipient_account,
            tr.receiving_channel,
            tr.remitting_bank,
            tr.remitting_account,
            tr.status,
            tr.create_time,
            tr.complete_time
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.payout-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
   .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    margin-right: 5px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }

}

</style>
